/* global window:false */

const chorus = window.chorus || {};

chorus.collections = {};
chorus.models = {};
chorus.views = {};

export default chorus;
